module.exports = __webpack_public_path__ + "static/img/strona_019.4245fd52.jpg";